"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Specialist = void 0;
const Resources_1 = require("../Resources");
class Specialist {
    constructor() {
        this.name = 'Specialist';
        this.description = 'Have at least 10 production of any resource';
    }
    getScore(player) {
        return Math.max(player.getProduction(Resources_1.Resources.MEGACREDITS), player.getProduction(Resources_1.Resources.STEEL), player.getProduction(Resources_1.Resources.TITANIUM), player.getProduction(Resources_1.Resources.PLANTS), player.getProduction(Resources_1.Resources.ENERGY), player.getProduction(Resources_1.Resources.HEAT));
    }
    canClaim(player) {
        return this.getScore(player) > 9;
    }
}
exports.Specialist = Specialist;
//# sourceMappingURL=Specialist.js.map